export default __webpack_public_path__ + "static/media/landing-agent-feature-3.fb4df740.svg";